export const WIN_MESSAGES = ['!', '', '!']
